var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertaErro(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse-2",
    cx: 25,
    cy: 25,
    rx: 25,
    ry: 25
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 0,
    y: 0,
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#ellipse-2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(205,45,55)",
    fillRule: "evenodd",
    d: "M31.76813187 15.09046145l3.14132444 3.14132621-7.26817414 7.26817006 7.26821322 7.2682173-3.14132621 3.14132445-7.26821322-7.2682173-7.26817414 7.26817006-3.14132445-3.14132621 7.26817414-7.26817006-7.2681269-7.26813098 3.14132621-3.14132445 7.2681269 7.26813098 7.26817415-7.26817006z"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    stroke: "rgb(205,45,55)",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 12,
    mask: "url(#mask-3)",
    xlinkHref: "#ellipse-2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaErro);
export default __webpack_public_path__ + "static/media/alerta_erro.4d83d054fd1890da1b0d3571606bdf13.svg";
export { ForwardRef as ReactComponent };